import { render, staticRenderFns } from "./BleachSwiper.vue?vue&type=template&id=c3a3e120"
import script from "./BleachSwiper.vue?vue&type=script&lang=js"
export * from "./BleachSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports